var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.781a.8.8 0 01.8-.8h1.125a.2.2 0 00.181-.116l.416-.9A.8.8 0 014.75 2.5h2.739a.8.8 0 01.727.464l.416.9a.2.2 0 00.181.117H13.7a.8.8 0 01.8.8V12.7a.8.8 0 01-.8.8H2.3a.8.8 0 01-.8-.8V4.781z",
    stroke: "#fff",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 2.4,
    stroke: "#fff",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.959 6.042h-1.334",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/camera.fbed1620.svg";
export { SvgCamera as ReactComponent };